import { NavLink, Link } from "react-router-dom"
export default function NavBar() {
  return <header className="sticky top-0 z-10 bg-white border-b border-gray-200">
    <nav aria-label="Main navigation" className="max-w-6xl mx-auto px-4 py-2 flex flex-col md:flex-row md:items-center md:justify-between">
      <Link to="/dashboard" className="font-semibold min-h-11 flex items-center">Gifting Made Easy</Link>
      <div className="flex gap-2">{[["/dashboard", "My list"], ["/users", "Find a list"], ["/account", "Account"]].map(([to, label]) => <NavLink key={to} to={to} className={({ isActive }) => `min-h-11 px-3 inline-flex items-center border-b-2 ${isActive ? "border-blue-600 text-blue-600 font-semibold" : "border-transparent text-gray-600"}`}>{label}</NavLink>)}</div>
    </nav>
  </header>
}
